import React, { useEffect, useState } from 'react';
import SahamAccordion from 'components/SahamAccordion';
import styled from 'styled-components';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import { injectIntl, IntlShape } from 'react-intl';
import BeneficiaryDrawer from 'containers/PreOpeningPage/BeneficiaryDrawer';
import BeneficiaryForm from 'containers/PreOpeningPage/BeneficiaryForm';
import { Listings } from 'containers/AppContainer/typings';
import { VictimType, BeneficiaryType } from 'typings/globalTypes';
export interface BeneficiaryProps {
  intl: IntlShape;
  beneficiary?: BeneficiaryType;
  index?: number; // beneficiary index
  listing: Listings;
  handleBeneficiaryChange: Function;
  handleSubmitEdit?: Function;
  handleDelete?: Function;
  handleCancel?: Function;
  couldDelete?: boolean;
  victim: VictimType;
  inputProps: any;
  disableInput: boolean | undefined;
  inputLabelProps: boolean | undefined;
  editButtonTitle?: string | null | undefined;
  isOpeningManager?: boolean;
  isCourtMonitoringManagerUpdate?: boolean;
  isDrawer: boolean;
  isLawyer?: boolean;
  isRejected?: boolean;
  isCourtManager?: boolean;
  lossDate?: string;
  isCourtManagerBasicManagement?: boolean;
  isDrawerAdd?: boolean;
  isProvisional?: boolean;
}
const Container = styled.div`
  .subContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 20px;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
    font-size: 14px;
  }
`;

const BeneficiaryAccordion: React.FC<BeneficiaryProps> = (
  props,
): JSX.Element => {
  const { beneficiary, index } = props;
  const [expanded, setExpanded] = React.useState(true);
  const [beneficiaryToUpdate, setBeneficiaryToUpdate] = useState({
    ...beneficiary,
  });

  useEffect(() => {
    setBeneficiaryToUpdate({ ...beneficiary } as any);
  }, [beneficiary]);

  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };

  const [
    isModificationDrawerOpen,
    setIsModificationDrawerOpen,
  ] = React.useState(false);

  const handleEditBeneficiary = (event: { stopPropagation: Function }) => {
    event.stopPropagation();
    handleToggleModificationDrawer();
  };

  const handleToggleModificationDrawer = () => {
    setIsModificationDrawerOpen(!isModificationDrawerOpen);
  };

  const accordionTitle = index
    ? translate({ ...messages.beneficiaryAccordionTitle }, props, {
        number: index + 1,
      })
    : translate({ ...messages.beneficiaryFormTitle }, props);
  return (
    <Container>
      <SahamAccordion
        expanded={expanded}
        onChange={handleChangeExpanded}
        title={accordionTitle}
        editButtonTitle={props.editButtonTitle}
        editButtonOnClick={handleEditBeneficiary}
      >
        <BeneficiaryForm
          isDrawer={false}
          isDrawerAdd={props.isDrawerAdd}
          isOpeningManager={props.isOpeningManager}
          listing={props.listing}
          couldDelete={
            props.couldDelete && !props.isCourtMonitoringManagerUpdate
          }
          beneficiary={beneficiary}
          handleSubmit={props.handleBeneficiaryChange}
          handleDelete={props.handleDelete}
          inputProps={props.inputProps}
          disableInput={props.disableInput}
          inputLabelProps={props.inputLabelProps}
          handleCancel={props.handleCancel}
          victim={props.victim}
          isLawyer={props.isLawyer}
          isRejected={props.isRejected}
          isCourtManager={props.isCourtManager}
          beneficiaryToUpdate={beneficiaryToUpdate}
          lossDate={props.lossDate}
          isCourtManagerBasicManagement={props.isCourtManagerBasicManagement}
          isProvisional={props.isProvisional}
        />
      </SahamAccordion>
      {/* benficiary drawer */}
      {beneficiary && props.handleSubmitEdit && isModificationDrawerOpen && (
        <BeneficiaryDrawer
          listing={props.listing}
          open={isModificationDrawerOpen}
          handleToggleDrawer={handleToggleModificationDrawer}
          beneficiary={beneficiary}
          isCourtMonitoringManagerUpdate={props.isCourtMonitoringManagerUpdate}
          handleSubmit={props.handleSubmitEdit}
          victim={props.victim}
          setBeneficiaryToUpdate={setBeneficiaryToUpdate}
          beneficiaryToUpdate={beneficiaryToUpdate}
          lossDate={props.lossDate}
        />
      )}
    </Container>
  );
};

export default injectIntl(BeneficiaryAccordion);
